import {authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'
   
const SubCategory = lazy(() => import('./SubCategory.jsx'))    

const SubCategoryRoutes = [
    {
        path: '/SubCategory',
        component: SubCategory,
        auth: authRoleAccess.subcategory,
    },
   
]

export default SubCategoryRoutes 